import React, { useEffect, useState } from 'react'

interface CurrentTimeIndicatorProps {
  startHour: number
  slotDuration: number
  slotHeight: number
}

export const CurrentTimeIndicator: React.FC<CurrentTimeIndicatorProps> = ({
  startHour,
  slotDuration,
  slotHeight,
}) => {
  const [position, setPosition] = useState<number | null>(null)

  useEffect(() => {
    const updatePosition = () => {
      const now = new Date()
      const currentHour = now.getHours()
      const currentMinute = now.getMinutes()

      // Check if current time is within calendar hours
      if (currentHour < startHour || currentHour >= 24) {
        setPosition(null)
        return
      }

      const totalMinutesFromStart = (currentHour - startHour) * 60 + currentMinute
      const slotIndex = totalMinutesFromStart / slotDuration
      const pos = slotIndex * slotHeight

      setPosition(pos)
    }

    updatePosition()
    const interval = setInterval(updatePosition, 60000) // Update every minute

    return () => clearInterval(interval)
  }, [startHour, slotDuration, slotHeight])

  if (position === null) return null

  return (
    <>
      {/* Line */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: position,
          height: '2px',
          backgroundColor: '#ef4444',
          zIndex: 10,
          pointerEvents: 'none',
        }}
      />
      {/* Dot */}
      <div
        style={{
          position: 'absolute',
          left: '-5px',
          top: position - 5,
          width: '10px',
          height: '10px',
          backgroundColor: '#ef4444',
          borderRadius: '50%',
          zIndex: 10,
          pointerEvents: 'none',
        }}
      />
    </>
  )
}
